import { TextQuestionDTO } from 'jobs/dtos/questions'
import QuestionViewModelBase, {
  QuestionViewModelPort,
} from '../QuestionViewModelBase'
import { action, observable, makeObservable } from 'mobx'
import { QuestionValidationResult } from '../QuestionValidationResult'
import { QuestionInputValue } from '../input-value-types'

export interface TextValidation {
  minLength: number
  maxLength: number
}

export interface TextSettings {
  multiLine: boolean
  showErrorMessages: boolean
}

export const TextSettings = {
  defaults: {
    multiLine: false,
    showRemainingCharacters: false,
    showErrorMessages: false,
  } as TextSettings,
}

export default class TextQuestionViewModel extends QuestionViewModelBase<TextQuestionDTO> {
  constructor(private textQuestionView: QuestionViewModelPort) {
    super(textQuestionView)

    makeObservable(this)
  }

  get isAnswered(): boolean {
    return this.answer !== ''
  }

  @observable answer = ''

  validations?: TextValidation
  settings: TextSettings = TextSettings.defaults

  configure(settings: TextSettings, validations?: TextValidation) {
    this.settings = settings
    this.validations = validations
    return this
  }

  protected textAnswer(): string {
    return this.answer
  }

  protected hydrateAnswer(answer: unknown): void {
    this.answer = answer ? String(answer) : ''
  }

  @action.bound
  change(newValue: string) {
    this.answer = newValue.trim()
    this.notify()
  }

  validate(): QuestionValidationResult {
    if (!this.answer) {
      return QuestionValidationResult.failed(['This field is required.'])
    }

    if (
      this.validations &&
      (this.answer.length > this.validations.maxLength ||
        this.answer.length < this.validations.minLength)
    ) {
      return QuestionValidationResult.failed([
        `Response must be between ${this.validations.minLength} and ${this.validations.maxLength} characters.`,
      ])
    }
    return QuestionValidationResult.ok()
  }

  protected serializeAnswer() {
    return this.answer
  }

  toInputValue(): QuestionInputValue {
    return { type: 'TEXT', value: this.answer }
  }
}
